module.exports = __webpack_public_path__ + "img/dev.82b2c943.jpg";